import { Box, Center, Text } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';

export const PostFeedError: React.FC = () => {
  return (
    <Card>
      <Center h={96}>
        <Box textAlign="center">
          <Text textStyle="bodyStrong" color="gray.700">
            Something went wrong
          </Text>
          <Text textStyle="body" color="gray.600">
            We are working on a fix
          </Text>
        </Box>
      </Center>
    </Card>
  );
};
